module.exports = __webpack_public_path__ + "img/17.1.885c0e11.jpg";